import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as attApi from '@/services/attendance-api';

export function useTodayAttendance(employeeId: string | null) {
  return useQuery({
    queryKey: ['attendance', 'today', employeeId],
    queryFn: () => (employeeId ? attApi.fetchTodayStatus(employeeId) : null),
    enabled: Boolean(employeeId),
    staleTime: 15_000,
  });
}

export function useClockAction(employeeId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (args: { action: 'in' | 'out'; lat?: number; lng?: number }) => {
      if (!employeeId) throw new Error('No employee record');
      const meta = {
        source: 'MOBILE' as const,
        ...(typeof args.lat === 'number' ? { lat: args.lat } : {}),
        ...(typeof args.lng === 'number' ? { lng: args.lng } : {}),
      };
      return args.action === 'in'
        ? attApi.clockIn(meta)
        : attApi.clockOut(meta);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['attendance', 'today', employeeId] });
    },
  });
}
